/**
 * @generated SignedSource<<c8081341f85d69e8eacb4ee5c7cc79c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type hydrantMeasurementReportPagemeasurementTemplatesQuery$variables = {};
export type hydrantMeasurementReportPagemeasurementTemplatesQueryVariables = hydrantMeasurementReportPagemeasurementTemplatesQuery$variables;
export type hydrantMeasurementReportPagemeasurementTemplatesQuery$data = {
  readonly measurementTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type hydrantMeasurementReportPagemeasurementTemplatesQueryResponse = hydrantMeasurementReportPagemeasurementTemplatesQuery$data;
export type hydrantMeasurementReportPagemeasurementTemplatesQuery = {
  variables: hydrantMeasurementReportPagemeasurementTemplatesQueryVariables;
  response: hydrantMeasurementReportPagemeasurementTemplatesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "assetType",
        "value": "hydrant"
      }
    ],
    "concreteType": "MeasurementTemplateConnection",
    "kind": "LinkedField",
    "name": "measurementTemplates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeasurementTemplateEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeasurementTemplate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "measurementTemplates(assetType:\"hydrant\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hydrantMeasurementReportPagemeasurementTemplatesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hydrantMeasurementReportPagemeasurementTemplatesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9e327f4e3c77adcdce28f45643ea608c",
    "id": null,
    "metadata": {},
    "name": "hydrantMeasurementReportPagemeasurementTemplatesQuery",
    "operationKind": "query",
    "text": "query hydrantMeasurementReportPagemeasurementTemplatesQuery {\n  measurementTemplates(assetType: hydrant) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "47f547efedb814af897fc569bdfe7004";

export default node;
